import {Component, Input, OnInit, AfterViewInit} from '@angular/core';

@Component({
  selector: 'app-analyticsphonesummary',
  templateUrl: './analyticsphonesummary.component.html',
  styleUrls: ['./analyticsphonesummary.component.css']
})
export class AnalyticsphonesummaryComponent implements AfterViewInit {
  @Input('details') details: any;
  @Input('average_calls_per_month') average_calls_per_month: any;
  @Input('average_monthly_cost') average_monthly_cost: number;

  constructor() {
  }

  ngAfterViewInit() {
    // function call_counts(item) {
    //   return item.call_count;
    // }

    // function call_cost(item) {
    //   return item.total_amount_spent;
    // }

    // function sum(prev, next) {
    //   return prev + next;
    // }

    // this.average_calls_per_month = (this.details.data.calls.map(call_counts).reduce(sum) / this.details.data.calls.length);
    // this.average_monthly_cost = (this.details.data.calls.map(call_cost).reduce(sum) / this.details.data.calls.length)
  }

}
